import { isMobile } from "../is-mobile";
export const isDateTypeSupported = () => {
    const el = document.createElement("input");
    const value = "a";
    el.setAttribute("type", "date");
    el.setAttribute("value", value);
    return el.type !== "text" || el.value !== value;
};
const isFirefox = () => navigator.userAgent.includes("Firefox");
/**
 * System native datepicker only when "type=date" is supported on mobile or when disabled
 */
export const hasNativeDatepicker = () => process.env.NODE_ENV === "test"
    ? false
    : isDateTypeSupported() && (isMobile || isFirefox());
